var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5 16.299 21 10.5 21zm-.698-6.716 5.45-5.31a1.228 1.228 0 0 0 0-1.77 1.307 1.307 0 0 0-1.817 0L8.894 11.63 7.076 9.86a1.307 1.307 0 0 0-1.817 0 1.23 1.23 0 0 0 0 1.77l2.726 2.655c.501.49 1.315.49 1.817 0z",
    fill: "#97C66B",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTick);
export default __webpack_public_path__ + "static/media/active-tick.b0c40aaf.svg";
export { ForwardRef as ReactComponent };